<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
    <div class="AllDataProvidedUpToThisPointWillBeLostIfYouCancelNowYouWillNeedToStartTheSignInProcessFromTheBeginning" style="width: 100%; color: #444746; font-size: 12px; font-family: Roboto; font-weight: 400; line-height: 19.92px; letter-spacing: 0.40px; word-wrap: break-word">
        {{ message }}
    </div>
</mat-dialog-content>
<div mat-dialog-actions [align]="'end'" name="hi">
    <button  mat-stroked-button (click)="onDismiss()" mat-button class="button-stepper-allow">
        {{ cancelButtonText }}
        <mat-icon>arrow_left_alt</mat-icon>
     </button>
  <button class="button-dialog-red" (click)="onConfirm()" mat-button cdkFocusInitial>{{ confirmButtonText }}</button>
</div>
